import { invokeSendEmail } from "@/api/messaging";

type FormType =
  | "play_submission"
  | "registration_confirmation"
  | "virtual_game_links"
  | "profile_email_verification";

interface EmailData {
  formType: FormType;
  data?: Record<string, string>;
}

interface SendFormEmailResult {
  success: boolean;
  error?: string;
  sent?: number;
  queued?: number;
}

export async function sendFormEmail(
  emailData: EmailData,
): Promise<SendFormEmailResult> {
  try {
    const { data, error } = await invokeSendEmail(emailData);

    if (error) {
      const response = error.context;
      if (response instanceof Response) {
        const body = await response.clone().json();
        return {
          success: false,
          error: typeof body?.error === "string" ? body.error : error.message,
        };
      }
      return { success: false, error: error.message };
    }

    return { success: true, sent: data?.sent, queued: data?.queued };
  } catch (err) {
    return { success: false, error: String(err) };
  }
}
